/** PULLDOWN VALUE LISTS */

const recruitmentStatuses = [
	'Recruiting',
	'Will Be Recruiting',
	'Recruitment Complete',
	'Completed',
	'Terminated|Withdrawn',
	// 'Active, not recruiting',
	// 'Approved for marketing',
	// 'Available',
	// 'Enrolling by invitation',
	// 'No longer available',
	// 'Not yet recruiting',
	// 'Suspended',
	// 'Terminated',
	// 'Withdrawn',
	// 'Withheld',
]

const sexes = [
	'Female',
	'Male',
	'All',
]

const trialPhases = [
	'Phase 1',
	'Phase 1/Phase 2',
	'Phase 2',
	'Phase 2/Phase 3',
	'Phase 3',
	'Phase 4',
	'N/A',
]

const trialTypes = [
	'Expanded Access',
	'Interventional',
	'Observational',
	'Observational [Patient Registry]',
	'N/A',
]


/** UTILITIES */

// React Select pulldown options
const getReactSelectOptions = (array) => {
	return array.map((item) => {
		return { value: item, label: item }
	})
}

const getRecruitStatusOptions = () => {
	return getReactSelectOptions(recruitmentStatuses)
}

const getSexOptions = () => {
	return getReactSelectOptions(sexes)
}

const getTrialPhaseOptions = () => {
	return getReactSelectOptions(trialPhases)
}

const getTrialTypeOptions = () => {
	return getReactSelectOptions(trialTypes)
}

export {
	// helpers
	getRecruitStatusOptions,
	getSexOptions,
	getTrialPhaseOptions,
	getTrialTypeOptions,
}